import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Support() {
  return (
    <div className="app">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <Link to="/" className="logo">
            <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
            <div className="logo-text">
              <span className="logo-title">AJWS</span>
              <span className="logo-subtitle">Anil Jindal World School</span>
            </div>
          </Link>
          <div className="nav-links">
            <Link to="/">Home</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </div>
        </div>
      </nav>

      <section className="support-section">
        <div className="container">
          <div className="support-content">
            <h1 className="support-title">Support & Help</h1>
            <p className="support-subtitle">
              We're here to help you with any questions or issues you may have with the AJWS app.
            </p>

            <div className="support-sections">
              <div className="support-card">
                <div className="support-icon">📧</div>
                <h2>Contact Us</h2>
                <p>Get in touch with our support team for assistance.</p>
                <div className="contact-details">
                  <p><strong>Company:</strong> Nyx Solutions</p>
                  <p><strong>Email:</strong> <a href="mailto:solutionnyx@gmail.com">solutionnyx@gmail.com</a></p>
                  <p><strong>Phone:</strong> <a href="tel:+919765723830">+91 9765723830</a></p>
                  <p><strong>Address:</strong> A 23/3, R K PLASTRONICS, MIDC AREA, JALNA, Maharashtra, 431203</p>
                  <p><strong>Office Hours:</strong> Monday - Friday, 9:00 AM - 5:00 PM</p>
                </div>
              </div>

              <div className="support-card">
                <div className="support-icon">❓</div>
                <h2>Frequently Asked Questions</h2>
                <div className="faq-list">
                  <div className="faq-item">
                    <h3>How do I create an account?</h3>
                    <p>Contact your school administration office to receive your login credentials. Your account will be set up based on your role (parent, teacher, administrator, or principal).</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>I forgot my password. What should I do?</h3>
                    <p>Use the "Forgot Password" link on the login screen. You'll receive instructions via email to reset your password. If you need further assistance, contact support.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>How do I add multiple children to my parent account?</h3>
                    <p>Once you log in as a parent, you can add multiple children from the settings or profile section. If you need help, contact your school administration.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>How do I message my child's teacher?</h3>
                    <p>Go to the Messaging section in the app, select your child's class, and choose the teacher you want to message. You can send messages directly through the app.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>Why can't I see my child's homework?</h3>
                    <p>Make sure you're logged in with the correct account and that your child is properly linked to your account. If the issue persists, contact your child's teacher or school administration.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>How do I submit a leave request?</h3>
                    <p>Navigate to the "Leave Requests" section, click "New Request," fill in the required details including dates and reason, and submit. You'll receive updates on the status of your request.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>Can I use the app offline?</h3>
                    <p>Some features are available offline, such as viewing previously loaded homework and schedules. However, you'll need an internet connection to send messages, submit leave requests, and view real-time updates.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>How do I change the app language?</h3>
                    <p>Go to Settings in the app, select "Language," and choose your preferred language from the available options.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>I'm a teacher. How do I share homework with parents?</h3>
                    <p>Go to the Homework section, select your class, click "Create Homework," fill in the details including due date and instructions, and publish. Parents will receive notifications.</p>
                  </div>
                  
                  <div className="faq-item">
                    <h3>How do I report a bug or technical issue?</h3>
                    <p>Please email us at <a href="mailto:solutionnyx@gmail.com">solutionnyx@gmail.com</a> with details about the issue, including your device type, app version, and steps to reproduce the problem.</p>
                  </div>
                </div>
              </div>

              <div className="support-card">
                <div className="support-icon">📱</div>
                <h2>App Information</h2>
                <div className="app-info">
                  <p><strong>App Name:</strong> AJWS - Anil Jindal World School</p>
                  <p><strong>Platform:</strong> iOS, Android, Web</p>
                  <p><strong>Purpose:</strong> School management and communication platform for parents, teachers, administrators, and principals</p>
                  <p><strong>Minimum Requirements:</strong></p>
                  <ul>
                    <li>iOS: Version 12.0 or later</li>
                    <li>Android: Version 8.0 (Oreo) or later</li>
                    <li>Internet connection for full functionality</li>
                  </ul>
                </div>
              </div>

              <div className="support-card">
                <div className="support-icon">🔒</div>
                <h2>Privacy & Security</h2>
                <p>Your privacy is important to us. We take data security seriously and protect your information according to industry standards.</p>
                <p>For detailed information about how we collect, use, and protect your data, please review our <Link to="/privacy-policy">Privacy Policy</Link>.</p>
              </div>

              <div className="support-card">
                <div className="support-icon">🔄</div>
                <h2>App Updates</h2>
                <p>We regularly update the app to add new features, improve performance, and fix bugs. Make sure you have automatic updates enabled on your device, or check the App Store/Google Play Store regularly for updates.</p>
                <p>If you encounter issues after an update, try:</p>
                <ul>
                  <li>Restarting the app</li>
                  <li>Logging out and logging back in</li>
                  <li>Clearing the app cache (if available)</li>
                  <li>Reinstalling the app if problems persist</li>
                </ul>
              </div>
            </div>

            <div className="support-note">
              <p>
                <strong>Note:</strong> For urgent matters or critical issues, please contact your school administration 
                office directly or use the emergency contact information provided by your school.
              </p>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img src="/School logo.png" alt="AJWS Logo" className="logo-image" />
              <div className="logo-text">
                <span className="logo-title">AJWS</span>
                <span className="logo-subtitle">Anil Jindal World School</span>
              </div>
            </div>
            <div className="footer-links">
              <div className="footer-column">
                <h4>Resources</h4>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/support">Support</Link>
                <Link to="/">Home</Link>
              </div>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} Anil Jindal World School. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Support;

